import type { BadgeRule } from "~/lib/badges/types";

export const stockStatusRule: BadgeRule = {
  name: "stockStatus",
  evaluate: (product, badge) => {
    if (badge.criteriaStockStatus === "Any stock status") return true;
    return product.stockStatus === badge.criteriaStockStatus;
  },
};
